var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 69,
    viewBox: "0 0 71 69",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M16.0724 56.8777C8.0246 56.8777 1.5 50.3747 1.5 42.3523C1.5 34.3264 8.0246 27.8234 16.0724 27.8234C17.038 27.8234 17.9832 27.9194 18.8944 28.0978M18.8944 28.0978C18.0958 25.9458 17.6881 23.6663 17.6908 21.3684C17.6908 10.6707 26.388 2 37.1184 2C47.1144 2 55.3458 9.52511 56.4304 19.2007M18.8944 28.0978C20.7756 28.4664 22.5664 29.2053 24.1644 30.2723M43.5954 19.2419C45.6776 18.51 47.8674 18.1378 50.0724 18.1409C52.296 18.1409 54.4346 18.5148 56.4304 19.2007M56.4304 19.2007C64.0328 21.8246 69.5 29.0307 69.5 37.5093C69.5 46.794 62.9482 54.5557 54.2 56.4421",
    stroke: "#C2C2C2",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.5 45.918V66.9991M35.5 45.918L42.4659 52.945M35.5 45.918L28.5342 52.945",
    stroke: "#5657FF",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/Upload.dc13086f3f8532992bdf5835fcf847bf.svg";
export { ForwardRef as ReactComponent };